var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReraicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 694.19",
    style: {
      enableBackground: "new 0 0 595.28 694.19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ad8a56",
    d: "M112.4,79.03v97.72L6.06,262.97h77.6v227.06c0,0,103.47-66.11,117.84,20.12c0,0,37.36-7.19,37.36,25.87 c0,0,48.86-4.31,48.86,31.62c0,0,107.78,4.31,40.24,106.34c0,0,54.61,21.56,43.11-45.99c0,0,61.79,38.8,51.74-37.36 c0,0,93.41,10.06,51.74-60.36c0,0,85.16,22.99,48.33-54.61L394.07,366.44h-80.48c0,0,1.44,102.62-103.47,77.9V79.03H112.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad8a56",
    d: "M290.71,22.88l-66.67,66.66v349.04c66.67-18.68,67.09-92.78,67.09-92.78h108.7l112.1,98.54v-179h77.28L290.71,22.88z  M299.63,266.09h-47.56v-47.56h47.56V266.09z M299.63,203.25h-47.56v-47.56h47.56V203.25z M355.68,266.09h-47.56v-47.56h47.56 V266.09z M355.68,203.25h-47.56v-47.56h47.56V203.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad8a56",
    d: "M104.31,520.96c0,0,63.69-64.54,78.13,10.19c0,0,45.01-7.64,44.16,37.37c0,0,50.95-17.83,47.56,30.57 c0,0,82.38-16.14,32.27,64.54c0,0-39.91,28.02-57.75-18.68c0,0-56.73,24.08-50.95-44.16c0,0-65.69,34.07-57.75-35.67 C139.97,565.12,84.77,583.8,104.31,520.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReraicon);
export default __webpack_public_path__ + "static/media/reraicon.b97632ab621eee4612294d12424366ed.svg";
export { ForwardRef as ReactComponent };